<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">ex和0x地址的关系</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">如何使用</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">相互转换</a></p>
          <!-- <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4"></a></p>
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5"></a></p> -->
          <!-- <div class="subAnchor">
            <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
            <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
            <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
            <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
            <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
            <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
            <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
          </div> -->
        </div>
      </div>
      <div class="p1">两种格式地址</div>
      <div id="box1" class="p2">ex和0x地址的关系</div>
      <div class="p3">ex中有两种地址格式，一种是ex前缀处的地址，如：ex1hcngft7gfkhn8z8fnlajzh7agyt0az0v6ztmme;另一种地址以0x开头，如：0x8aF3B04bF0400b16911b5A12360122148056d562.前缀为0x和ex的地址来自同一个助记词，其地址下的余额是相同的，两个地址下的所有者的okt数量相同。助记词导入metamask后，可以恢复0x开头的地址；使用exchaincli查看0x和ex开头的地址。可以在dex网页和手机客户端查看带有ex的地址前缀。</div>
      <div id="box2" class="p2">如何使用</div>
      <div class="p3">以ex开头的地址可以直接在手机客户端、网页或exchaincli上进行转账、充值、投票等操作。以0x开头的地址目前只能用于metamask的转账操作。</div>
      <div class="p3">Note: 使用前缀为ex的地址只能转账到前缀为ex的地址，不能交叉转账。</div>
      <div id="box3" class="p2">相互转换</div>
      <div class="p3">0x前缀的地址和ex前缀的地址来自同一个助记词，可以相互转换。0x开头的地址是Hex格式，以太坊目前使用这种格式的地址。 ex的前缀，格式规范来自btc协议BIP173（bech32），目前btc和cosmos都使用这种格式地址。</div>
      <div class="p3">两种格式的地址可以相互转换，转换方法：使用exchain-java-sdk、exchain-javascript-sdk方法convertAddressFromHexToBech32和方法convertAddressFromBech32ToHex转换</div>

      
    </div>
    
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">ex和0x地址的关系</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">如何使用</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">相互转换</a></p>
      <!-- <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4"></a></p>
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5"></a></p> -->
      <!-- <div class="subAnchor">
        <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
        <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
        <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
        <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
        <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
        <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
        <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'twoFormatAddress',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      overflow: auto
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
        word-break: break-all
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>